import Highcharts3dChart from './Highcharts3dChart';
export default Highcharts3dChart;